module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "data-pdf-bookmark": "Part II. Meet the Team . . .",
      "data-type": "part",
      "epub:type": "part",
      "id": "d1e1155"
    }
  }, [_c('h1', {
    staticClass: "PartTitlept"
  }, [_c('span', {
    attrs: {
      "href": "#/toc01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meet the Team . . .")])]), _c('h1', {
    staticClass: "PartTitlept"
  }, [_c('span', {
    attrs: {
      "href": "#/toc01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TROUBLE COMES IN SPADES.")])]), _c('figure', {
    staticClass: "Illustrationholderill customimage"
  }, [_c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "Spade.png",
      "src": "Spade.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Head-Level-1h1"
  }, [_vm._v("Meet the Spades . . .")]), _c('blockquote', [_c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("That girl CLEO gets around. Pop, she’s here, pop, she’s there, pop, she’s just behind you. Watch out for")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("CLEOPATRA!")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Cleonida Simpson")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Montgomery, Alabama")])]), _vm._v(" "), _c('p', {
    staticClass: "SpaceBreak-PrintOnlypo"
  }, [_vm._v("* * *")]), _c('blockquote', [_c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("RACHEL has the bestest collection of stuffies anywhere. They’re all so soft and cute and cuddly, just like")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("DRAGON HUNTRESS!")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Rachel Weinstein")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Bayonne, New Jersey")])]), _vm._v(" "), _c('p', {
    staticClass: "SpaceBreak-PrintOnlypo"
  }, [_vm._v("* * *")]), _c('blockquote', [_c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("An iron man from the Iron Range, WALLY has steel in his fists and a furnace for a heart. Rust never sleeps, and neither does")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("RUSTBELT!")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Wally “Rusty” Gunderson")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Mountain Iron, Minnesota")])]), _vm._v(" "), _c('p', {
    staticClass: "SpaceBreak-PrintOnlypo"
  }, [_vm._v("* * *")]), _c('blockquote', [_c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("THE KING is the mystery man from down along the border. Where is he from? What can he do? Who dares to look beneath the mask of")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("KING COBALT!")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("name unknown")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Somewhere in California")])]), _vm._v(" "), _c('p', {
    staticClass: "SpaceBreak-PrintOnlypo"
  }, [_vm._v("* * *")]), _c('blockquote', [_c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("There’s never a loser when ROSA deals the cards. Diva or demon, snake or lion, even death itself, they’re all in the hands of")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("ROSA LOTERIA!")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Guadelupe Maria del Rosario Garza")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("East Los Angeles, California")])]), _vm._v(" "), _c('p', {
    staticClass: "SpaceBreak-PrintOnlypo"
  }, [_vm._v("* * *")]), _c('blockquote', [_c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("ALI likes to dust things up. The girl has got a little devil in her. From the land of Elvis and the Living Gods comes")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("SIMOON!")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Aliyah Malik")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Las Vegas, Nevada")])]), _vm._v(" "), _c('p', {
    staticClass: "SpaceBreak-PrintOnlypo"
  }, [_vm._v("* * *")]), _c('blockquote', [_c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("JOHN burns bright by day and night in half a hundred hues. Let those who hide in darkness cower, and beware the light of")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("THE CANDLE!")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("John Montano")]), _vm._v(" "), _c('p', {
    staticClass: "Extract-NoIndentext1"
  }, [_vm._v("Durango, Colorado")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa23496c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/part02.vue
// module id = 75
// module chunks = 0